import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'

export const PARTNERPLANADMIN_GET = 'PARTNERPLANADMIN_GET'
export const PARTNERPLANADMIN_RECEIVED = 'PARTNERPLANADMIN_RECEIVED'
export const PARTNERPLANADMIN_GET_ERROR = 'PARTNERPLANADMIN_GET_ERROR'
export const PARTNERPLANADMIN_SELECTEDOVERVIEWPAGE = 'PARTNERPLANADMIN_SELECTEDOVERVIEWPAGE'
export const PARTNERPLANADMIN_OVERVIEWPAGE = 'PARTNERPLANADMIN_OVERVIEWPAGE'
export const PARTNERPLANADMIN_UPLOADLOGRECEIVED = 'PARTNERPLANADMIN_UPLOADLOGRECEIVED'

const fetching = type => ({
  type,
})

const fetchingerror = type => ({
  type,
})

const partnerPlanAdminReceive = item => ({
  type: PARTNERPLANADMIN_RECEIVED,
  item,
})

const partnerPlanAdminUploadLogReceive = item => ({
  type: PARTNERPLANADMIN_UPLOADLOGRECEIVED,
  item,
})

const partnerPlanOverviewPage = item => ({
  type: PARTNERPLANADMIN_OVERVIEWPAGE,
  item,
})

const selectedOverviewPage = item => ({
  type: PARTNERPLANADMIN_SELECTEDOVERVIEWPAGE,
  item,
})

export function setSelectedOverviewPage(item) {
  return (dispatch) => {
    dispatch(selectedOverviewPage(item))
  }
}

export function getPartnerPlanOverviewPages(employeeId) {
  return (dispatch) => {
    dispatch(fetching(PARTNERPLANADMIN_GET))
    agent.PartnerPlanAdmin.listoverviewpages(employeeId)
      .then((result) => {
        dispatch(partnerPlanAdminReceive(result))
      })
      .catch((rawError) => {
        // console.error('getPartnerPlanOverviewPages error', rawError, rawError.stack, window.location)
        console.error('Getting partner plan overview pages error')
        const { error, status, description } = parseError(rawError)
        if (status === constants.ERROR.INTERNAL_SERVER) {
          dispatch(push({
            pathname: '/error',
            search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
          }))
        } else if (status === constants.ERROR.UNAUTHORIZED) {
          updateSessionObject()
        } else {
          dispatch(notify(description))
          dispatch(notify('Error fetching partner plan overview', 'warning'))
          dispatch(push({ pathname: '/' }))
        }
      })
  }
}

export function getPartnerPlanUploadLogs(employeeId, numDays) {
  return (dispatch) => {
    dispatch(fetching(PARTNERPLANADMIN_GET))
    agent.PartnerPlanAdmin.listuploadlog(employeeId, numDays)
      .then((result) => {
        dispatch(partnerPlanAdminUploadLogReceive(result))
      })
      .catch((rawError) => {
        // console.error('getPartnerPlanUploadLogs error', rawError, rawError.stack, window.location)
        console.error('Getting partner plan upload logs error')
        const { error, status, description } = parseError(rawError)
        if (status === constants.ERROR.INTERNAL_SERVER) {
          dispatch(push({
            pathname: '/error',
            search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
          }))
        } else if (status === constants.ERROR.UNAUTHORIZED) {
          updateSessionObject()
        } else {
          dispatch(notify(description))
          dispatch(notify('Error fetching partner plan upload logs', 'warning'))
          dispatch(push({ pathname: '/' }))
        }
      })
  }
}

export function getCurrentOverviewPage(employeeId) {
  return (dispatch) => {
    dispatch(fetching(PARTNERPLANADMIN_GET))
    agent.PartnerPlanAdmin.getcurrentoverviewpage(employeeId)
      .then((result) => {
        dispatch(partnerPlanOverviewPage(result))
      })
      .catch((rawError) => {
        // console.error('getCurrentOverviewPage error', rawError, rawError.stack, window.location)
        console.error('Getting current overview page error')
        const { error, status, description } = parseError(rawError)
        if (status === constants.ERROR.INTERNAL_SERVER) {
          dispatch(push({
            pathname: '/error',
            search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
          }))
        } else if (status === constants.ERROR.UNAUTHORIZED) {
          updateSessionObject()
        } else {
          dispatch(notify(description))
          dispatch(notify('Error fetching current partner plan overview page', 'warning'))
          dispatch(push({ pathname: '/' }))
        }
      })
  }
}

export function setCurrentOverviewPageActive(employeeId, planstage) {
  return (dispatch) => {
    dispatch(fetching(PARTNERPLANADMIN_GET))
    agent.PartnerPlanAdmin.setoverviewpageactive(employeeId, planstage)
      .then((result) => {
        dispatch(partnerPlanAdminReceive(result))
        dispatch(notify(`${planstage} overview page successfully opened`))
      })
      .catch((rawError) => {
        // console.error('setCurrentOverviewPageActive error', rawError, rawError.stack, window.location)
        console.error('Set current overview page active error')
        const { error, status, description } = parseError(rawError)
        if (status === constants.ERROR.INTERNAL_SERVER) {
          dispatch(push({
            pathname: '/error',
            search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
          }))
        } else if (status === constants.ERROR.UNAUTHORIZED) {
          updateSessionObject()
        } else {
          dispatch(notify(description))
          dispatch(notify(`Error opening ${planstage} overview page`, 'warning'))
          dispatch(push({ pathname: '/' }))
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/partnerPlanAdmin.js